module.exports = __webpack_public_path__ + "static/img/img-p1-3gs.2de57879.jpg";